import { render } from "./crmIndex.vue?vue&type=template&id=18eec076&scoped=true"
import script from "./crmIndex.vue?vue&type=script&lang=js"
export * from "./crmIndex.vue?vue&type=script&lang=js"

import "./crmIndex.vue?vue&type=style&index=0&id=18eec076&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18eec076"]])

export default __exports__